import produce from 'immer';

// TYPES
import { Types, ExcluirSufixo } from './types';
import { ReducerAction } from '../../../../../types';

export const INITIAL_STATE: ExcluirSufixo = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ExcluirSufixo {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_SUFIXO: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_SUFIXO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_SUFIXO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_SUFIXO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
